"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledAvatar = _styledComponents.default.img(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  flex: 0 0 ", ";\n  object-fit: cover;\n  width: ", ";\n  min-width: ", ";\n  max-width: ", ";\n  height: ", ";\n  min-height: ", ";\n  max-height: ", ";\n  border-radius: 50%;\n"])), function (p) {
  return p.size;
}, function (props) {
  return props.size;
}, function (props) {
  return props.size;
}, function (props) {
  return props.size;
}, function (props) {
  return props.size;
}, function (props) {
  return props.size;
}, function (props) {
  return props.size;
});

var Avatar = function Avatar(_ref) {
  var src = _ref.src,
      size = _ref.size;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledAvatar, {
    src: src,
    size: size
  });
};

Avatar.defaultProps = {
  size: "40px"
};
Avatar.propTypes = {
  src: _propTypes.default.string.isRequired,
  size: _propTypes.default.string
};
var _default = Avatar;
exports.default = _default;